"use strict";
import { StaticJsonRpcProvider } from "@ethersproject/providers";
import { AVERAGE_L1_BLOCK_TIME } from "constants/chains";
export default class ConfiguredJsonRpcProvider extends StaticJsonRpcProvider {
  constructor(url, networkish, pollingInterval = AVERAGE_L1_BLOCK_TIME) {
    super(url, networkish);
    this.pollingInterval = pollingInterval;
  }
}
